export default {"src":"/_next/static/media/Close.685ca0d4.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};